function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DndProvider, DndContext, useDragDropManager } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
var GLOBAL_KEY = '__EDUSENSE_DND_MANAGER__';
var getGlobalContext = function() {
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }
    // Fallback for environments where globalThis is not defined.
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    return {};
};
var acquireSharedManager = function() {
    var context = getGlobalContext();
    var storedState = context[GLOBAL_KEY];
    if (storedState === null || storedState === void 0 ? void 0 : storedState.manager) {
        storedState.refCount += 1;
        return storedState.manager;
    }
    if (!storedState) {
        context[GLOBAL_KEY] = {
            manager: undefined,
            refCount: 0
        };
    }
    return undefined;
};
var releaseSharedManager = function() {
    var context = getGlobalContext();
    var storedState = context[GLOBAL_KEY];
    if (!storedState || !storedState.manager) {
        return;
    }
    storedState.refCount -= 1;
    if (storedState.refCount <= 0) {
        var _storedState_manager_getBackend_teardown, _storedState_manager_getBackend, _storedState_manager;
        (_storedState_manager = storedState.manager) === null || _storedState_manager === void 0 ? void 0 : (_storedState_manager_getBackend = _storedState_manager.getBackend()) === null || _storedState_manager_getBackend === void 0 ? void 0 : (_storedState_manager_getBackend_teardown = _storedState_manager_getBackend.teardown) === null || _storedState_manager_getBackend_teardown === void 0 ? void 0 : _storedState_manager_getBackend_teardown.call(_storedState_manager_getBackend);
        context[GLOBAL_KEY] = {
            manager: undefined,
            refCount: 0
        };
    }
};
var registerSharedManager = function(manager) {
    var context = getGlobalContext();
    var storedState = context[GLOBAL_KEY];
    var nextState = storedState !== null && storedState !== void 0 ? storedState : {
        manager: undefined,
        refCount: 0
    };
    nextState.manager = manager;
    nextState.refCount += 1;
    context[GLOBAL_KEY] = nextState;
};
var DndManagerBridge = function(param) {
    var onReady = param.onReady, children = param.children;
    var manager = useDragDropManager();
    var notifiedRef = useRef(false);
    useEffect(function() {
        if (!notifiedRef.current && manager) {
            onReady(manager);
            notifiedRef.current = true;
        }
    }, [
        manager,
        onReady
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
/**
 * 여러 라우트/컴포넌트에서 동시에 React DnD를 사용할 때 HTML5 backend 중복 초기화를 방지하는 Provider.
 * 기존 Provider가 이미 존재하면 그대로 통과시키고, 없을 때만 전역으로 공유되는 매니저를 생성한다.
 */ export var SafeDndProvider = function(param) {
    var children = param.children;
    var ancestorManager;
    try {
        ancestorManager = useDragDropManager();
    } catch (error) {
        ancestorManager = undefined;
    }
    if (ancestorManager) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    var hasRegisteredRef = useRef(false);
    var _useState = _sliced_to_array(useState(function() {
        var manager = acquireSharedManager();
        if (manager) {
            hasRegisteredRef.current = true;
        }
        return manager;
    }), 2), sharedManager = _useState[0], setSharedManager = _useState[1];
    useEffect(function() {
        return function() {
            if (hasRegisteredRef.current) {
                releaseSharedManager();
            }
        };
    }, []);
    var handleManagerReady = useCallback(function(manager) {
        registerSharedManager(manager);
        hasRegisteredRef.current = true;
        setSharedManager(manager);
    }, []);
    if (sharedManager) {
        return /*#__PURE__*/ React.createElement(DndContext.Provider, {
            value: {
                dragDropManager: sharedManager
            }
        }, children);
    }
    return /*#__PURE__*/ React.createElement(DndProvider, {
        backend: HTML5Backend
    }, /*#__PURE__*/ React.createElement(DndManagerBridge, {
        onReady: handleManagerReady
    }, children));
};
export default SafeDndProvider;
